import type { Image } from '~kui/types/kui';

export interface UserLearningCampaignEntry {
  id: string;
}

export interface UserEligibilityChecksShape {
  isCampaignValid: boolean;
  isLearningCollectionCompleted: boolean;
  isAccountDetailsCompleted: boolean;
  hasUserEnteredCampaignPrize: boolean;
}

/**
 * Per-draw journey state derived from learning progress + entry status. Phoenix re-exports this
 * from `utils/unified/prizeDrawState.ts`, where `derivePrizeDrawState` answers it.
 */
export type PrizeDrawState
  = | 'not-started'
    | 'just-started'
    | 'almost-there'
    | 'complete-not-entered'
    | 'complete-at-school'
    | 'complete'
    | 'entered';

export const PrizeState = {
  CampaignEnded: 'CAMPAIGN_ENDED',
  LearningIncomplete: 'LEARNING_INCOMPLETE',
  AccountIncomplete: 'ACCOUNT_INCOMPLETE',
  ReadyToEnter: 'READY_TO_ENTER',
  Entered: 'ENTERED',
} as const;

// eslint-disable-next-line ts/no-redeclare
export type PrizeState = (typeof PrizeState)[keyof typeof PrizeState];

export interface OverviewActiveCampaign {
  id: string;
  name: string;
  /** The campaign's own line in front of the partner logo; null falls back to the prize wording. */
  attributionLabel?: string | null;
  /** Stored on the campaign: false means no draw, so every entry affordance stays off. */
  hasPrize: boolean;
  rewardText?: string | null;
  /** Game-of-skill question required to enter; null when the campaign has none. */
  skillQuestion?: string | null;
  campaignPartnerLogo?: Image;
  campaignSubtitle?: string | null;
  campaignDescription?: string | null;
  heroImageUrl?: string | null;
  userEligibilityChecks?: UserEligibilityChecksShape | null;
  prizeState?: PrizeState | null;
  currentUserLearningCampaignEntry?: UserLearningCampaignEntry | null;
  faqs: FaqItem[];
  startDate?: string | null;
  endDate?: string | null;
}

export interface FaqItem {
  heading: string;
  content: string[] | string;
}
